var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsheetExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 77,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.761,
    cy: 41.504,
    r: 35.239,
    fill: "#E6F6D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.022,
    cy: 40.721,
    r: 36.022,
    fill: "#DEF0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gsheet_export_svg__clip0_297_4713)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gsheet_export_svg__clip1_297_4713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.529 30.364h11.36l-11.36-11.36v11.36z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.529 30.362v-11.36h-19.021A2.502 2.502 0 00162 21.51v39.714a2.502 2.502 0 002.508 2.508h27.873a2.503 2.503 0 002.509-2.508V30.362h-11.361z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.271 36.551v15.374h20.348V36.55h-20.348zm8.915 12.866h-6.407v-3.93h6.407v3.93zm0-6.428h-6.407v-3.93h6.407v3.93zm8.925 6.428h-6.407v-3.93h6.407v3.93zm0-6.428h-6.407v-3.93h6.407v3.93z",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.148 26.573a25.118 25.118 0 014.48 14.681c0 .184.245.266.347.102.41-.673.757-1.368 1.085-2.082a21.872 21.872 0 00.47-17.03 23.064 23.064 0 00-17.368-4.818c-.184.02-.225.286-.04.368a24.346 24.346 0 0111.026 8.78z",
    fill: "#3088F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.515 40.336a24.73 24.73 0 01-10.883 11.72c-.164.102-.102.347.082.347 1.145 0 2.312-.081 3.437-.265a23.021 23.021 0 0014.094-8.025 23 23 0 00-4.52-17.56c-.123-.163-.369-.04-.328.143.696 4.615.041 9.352-1.882 13.64zM28.522 26.493a23.905 23.905 0 0114.197 3.512c.164.102.368-.082.266-.245a22.626 22.626 0 00-1.043-1.654 21.905 21.905 0 00-14.627-9.209 23.551 23.551 0 00-12.95 12.66c-.081.183.144.347.287.224a25.917 25.917 0 0113.87-5.288z",
    fill: "#3088F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.625 54.77a24.487 24.487 0 01-3.867.307 23.813 23.813 0 01-12.888-3.839c-.163-.102-.368.082-.265.245.43.776.9 1.511 1.431 2.226 3.58 4.716 8.838 7.881 14.668 8.882a23.567 23.567 0 0012.99-12.7c.082-.184-.143-.347-.286-.225a26.181 26.181 0 01-11.783 5.105z",
    fill: "#3088F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.921 55.323a23.436 23.436 0 01-4.664-15.049c0-.184-.245-.265-.348-.102a20.394 20.394 0 00-.94 1.736 22.221 22.221 0 00-.574 17.13 23.256 23.256 0 0017.614 4.983c.184-.02.225-.286.04-.368a25.98 25.98 0 01-11.128-8.33z",
    fill: "#3088F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 40.928a23.406 23.406 0 0110.76-11.516c.164-.082.102-.348-.082-.348-.654-.02-1.33 0-1.984.041a22.186 22.186 0 00-15.18 8.045 23.105 23.105 0 004.44 17.723c.123.164.368.041.327-.143a25.918 25.918 0 011.719-13.802z",
    fill: "#3088F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.286 32.89l8.86 8.86-8.86 8.859",
    stroke: "#515864",
    strokeWidth: 3.132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.317 41.268a1.566 1.566 0 10-2.378 2.038l2.379-2.038zm30.918 6.5l.368 1.523-.368-1.522zm-33.296-4.462c3.587 4.185 15.039 10.48 33.664 5.985l-.735-3.045c-17.711 4.275-27.873-1.854-30.55-4.978l-2.379 2.038zm33.664 5.985c5.865-1.416 9.576-3.713 11.487-6.528 1.96-2.887 1.849-6.054.625-8.676-1.2-2.571-3.485-4.683-6.058-5.72-2.595-1.048-5.675-1.056-8.183.95l1.956 2.447c1.407-1.126 3.222-1.232 5.056-.493 1.857.75 3.535 2.308 4.391 4.14.832 1.784.868 3.756-.378 5.593-1.295 1.907-4.142 3.917-9.631 5.242l.735 3.045zm-2.13-19.973c-4.491 3.593-6.307 10.706-5.263 16.759.53 3.077 1.82 6.043 4.033 8.256 2.241 2.24 5.337 3.616 9.257 3.616v-3.133c-3.129 0-5.416-1.072-7.042-2.698-1.653-1.653-2.713-3.974-3.161-6.573-.914-5.302.794-11.11 4.133-13.782l-1.956-2.445zm8.027 28.63c7.83 0 11.362-5.205 15.543-9.023 2.155-1.968 4.612-3.777 8.078-4.932 3.476-1.159 8.081-1.697 14.567-.934l.366-3.11c-6.827-.804-11.912-.265-15.924 1.072-4.023 1.341-6.852 3.448-9.199 5.59-4.825 4.406-7.166 8.205-13.431 8.205v3.133z",
    fill: "#515864"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.908,
    cy: 5.482,
    r: 4.699,
    stroke: "#5CB85C",
    strokeWidth: 1.566
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.092,
    cy: 28.975,
    r: 5.482,
    fill: "#A3C7F0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.401,
    cy: 11.746,
    r: 3.915,
    fill: "#A0D697"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.14,
    cy: 61.081,
    r: 2.349,
    stroke: "#3A92E5",
    strokeWidth: 1.566
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gsheet_export_svg__clip0_297_4713"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(162 19)",
    d: "M0 0h33v45H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gsheet_export_svg__clip1_297_4713"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(162 19)",
    d: "M0 0h32.89v44.736H0z"
  })))));
}
export default SvgGsheetExport;